<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-center>
        <v-flex md8 offset-md2 xs12>
          <v-card>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex md8 offset-md2 xs12>
                  <h1 v-if="editTopicId == null">
                    {{ $vuetify.t('$vuetify.TopicCreation.pageTitleCreating') }}
                  </h1>
                  <h1 v-else>
                    {{ $vuetify.t('$vuetify.TopicCreation.pageTitleEditing') }}
                  </h1>
                </v-flex>
                <v-flex md8 offset-md2 xs12>
                  <v-text-field
                    name="title"
                    :label="$vuetify.t('$vuetify.TopicCreation.title')"
                    :hint="$vuetify.t('$vuetify.TopicCreation.titleHint')"
                    v-validate="'required|max:160'"
                    :error-messages="errors.collect('title')"
                    required
                    v-model="title"
                    :disabled="isLoadingTopic"
                    :loading="isLoadingTopic"
                  ></v-text-field>
                </v-flex>
                <v-flex md8 offset-md2 xs12>
                  <h3>{{ $vuetify.t('$vuetify.TopicCreation.description') }}</h3>
                   <quill-editor class="editor-example bubble"
                          ref="topicEditor"
                          :content="description"
                          :options="editorOptions"
                          @change="onEditorChange($event)"
                          >
                      <div id="toolbar" slot="toolbar">
                        <!-- Add a bold button -->
                        <button class="ql-bold">Bold</button>
                        <button class="ql-italic">Italic</button>
                        <button class="ql-link">Link</button>
                        <button class="ql-image">Image</button>
                        <button class="ql-video">Video</button>
                        <button class="ql-align" value="center">Align Center</button>
                        <button class="ql-list" value="ordered">Ordered List</button>
                        <button class="ql-list" value="bullet">Bullet List</button>
                        <!-- Add font size dropdown -->
                        <select class="ql-size">
                          <option value="small"></option>
                          <!-- Note a missing, thus falsy value, is used to reset to default -->
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                        <select class="ql-font">
                          <option selected="selected"></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                        </select>
                      </div>
                   </quill-editor>

                  <!-- <v-textarea
                    name="description"
                    :label=""
                    :hint="$vuetify.t('$vuetify.TopicCreation.descriptionHint')"
                    v-validate="'required'"
                    required
                    :error-messages="errors.collect('description')"
                    v-model="description"
                    :disabled="isLoadingTopic"
                    :loading="isLoadingTopic"
                    ></v-textarea> -->
                </v-flex>
                <v-flex md8 offset-md2 xs12>
                  <v-img v-if="topicImage && topicImage !== ''" :src="topicImage?topicImage:''" :contain="true" height="300" />
                </v-flex>
                <v-flex md8 offset-md2 xs12>
                  <vue-base64-file-upload
                    v-if="isFileSizeReset"
                    accept="image/png,image/jpeg,image/svg"
                    image-class="upload-image-preview"
                    input-class="upload-image-input"
                    :value="topicImage"
                    :placeholder="$vuetify.t('$vuetify.Form.picture')"
                    :max-size="maxImageFileSize"
                    @size-exceeded="onSizeExceeded"
                    @load="onLoad" />
                </v-flex>

                <v-flex class="select-ideas" md8 offset-md2 xs12>
                  <h2>{{ $vuetify.t('$vuetify.TopicCreation.currentIdeas') }}</h2>
                  <v-list two-line dense>
                    <template v-for="(idea, index) in currentIdeas">
                      <v-list-tile :key="idea.id">
                        <v-list-tile-avatar>
                          <v-icon @click="removeIdea(idea)">delete</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ idea.title }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ idea.description }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                  <h2>{{ $vuetify.t('$vuetify.TopicCreation.selectIdeas') }}</h2>
                  <v-alert
                    :value="errors.has('selectIdeas')"
                    type="warning"
                  >{{ errors.first('selectIdeas')}}</v-alert>
                  <v-list two-line dense>
                    <template v-for="(idea, index) in unassignedIdeas">
                      <v-list-tile :key="idea.id">
                        <v-list-tile-avatar>
                          <v-checkbox
                            name="selectIdeas"
                            v-model="selected"
                            :value="idea.id"
                            :v-validate="shouldValidateWildIdeas"
                          ></v-checkbox>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ idea.title }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ idea.description }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
                <v-flex xs12 md8 offset-md2 pa-2 align-center justify-center text-md-center text-xs-center>
                  <v-btn
                    @click="submit"
                    color="primary"
                    dark
                  >{{ $vuetify.t('$vuetify.TopicCreation.publish') }}</v-btn>
                  <v-btn
                    v-if="this.$route.params.topicId != null"
                    :to="{ name: 'Topic', spaceSlug: this.$route.params.spaceSlug, topicId: this.$route.params.topicId }"
                    dark
                  >{{ $vuetify.t('$vuetify.TopicCreation.cancel') }}</v-btn>
                  <v-btn
                    v-if="this.$route.params.topicId == null"
                    @click="$router.back()"
                    dark
                  >{{ $vuetify.t('$vuetify.Form.cancel') }}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar v-model="showSnackbar" :bottom="true">
        {{ snackbarMsg }}
        <v-btn
          color="accent"
          flat
          @click="showSnackbar = false"
        >{{ $vuetify.t('$vuetify.Snackbar.close') }}</v-btn>
      </v-snackbar>
      <FileSizeUploadErrorDialog ref="fileSizeUploadErrorDialog"></FileSizeUploadErrorDialog>
    </v-container>
  </v-slide-y-transition>
</template>

<script>

import VueBase64FileUpload from 'vue-base64-file-upload'
import * as spaceApi from '@/api/ideaSpace'
import * as topicApi from '@/api/topic'
import ideaApi from '@/api/idea'
import FileSizeUploadErrorDialog from './dialogs/FileSizeUploadErrorDialog'
import {Quill} from 'vue-quill-editor'
import ImageCompress from 'quill-image-compress'
Quill.register('modules/imageCompress', ImageCompress)

export default {
  $_veeValidate: { validator: 'new' },

  components: { VueBase64FileUpload, FileSizeUploadErrorDialog },

  name: 'TopicEdit',
  props: {
    spaceSlug: ''
  },

  data: () => ({
    title: '',
    description: '',
    tab: 0,
    selected: [],
    ideas: [],
    showSnackbar: false,
    snackbarMsg: '',
    topicImage: null,
    isLoadingTopic: false,
    isFileSizeReset: true,
    phases: ['edit_topics', 'feasibility', 'vote', 'finished'],
    editorOptions: {
      placeholder: '...',
      modules: {
        imageCompress: {
          quality: 0.8,
          maxWidth: 1000,
          maxHeight: 1000,
          imageType: 'image/jpeg'
        },
        toolbar: '#toolbar'
      }
    },
    dictionary: {
      custom: {
        title: {
          required: 'Bitte gib dem Thema einen Namen',
          max: 'Das ist zu lang! Bitte gib dem Thema einen kurzen, eingängigen Namen.'
        },
        description: {
          required: 'Bitte gib eine Beschreibung für dieses Thema ein'
        },
        selectIdeas: {
          required: 'Bitte wähle mindestens eine Idee für das neue Thema'
        }
      }
    },
    maxImageFileSize: 2 // in mb
  }),

  beforeMount: function () {
    if (!this.spaceId) {
      if (this.$route.params['spaceSlug'] !== 'school') {
        spaceApi.getSpace(this.$store.getters.selected_school, this.$route.params['spaceSlug'])
          .then((res) => {
            this.spaceId = res.data[0].id
            this.getIdeas(this.$store.getters.selected_school, this.spaceId)
          })
      } else {
        this.getIdeas(this.$store.getters.selected_school)
      }
    } else {
      this.getIdeas(this.$store.getters.selected_school, this.spaceId)
    }
    if (this.editTopicId != null) {
      this.getTopic()
    }
  },

  mounted () {
    this.$validator.localize('en', this.dictionary)
  },

  computed: {
    editTopicId: function () {
      return this.$route.params['topicId']
    },

    shouldValidateWildIdeas: function () {
      if (this.editTopicId == null) {
        return 'required'
      } else {
        return null
      }
    },

    unassignedIdeas: function () {
      return this.ideas.filter(i => !i.topic)
    },

    currentIdeas: function () {
      return this.ideas.filter(i => i.topic)
    }
  },

  methods: {
    removeIdea: function (idea) {
      ideaApi.updateIdeas([idea.id], { 'topic': null }).then(res => {
        if (res.status === 204) {
          let removedIdeaIdx = this.ideas.findIndex(i => i.id === idea.id)
          this.ideas[removedIdeaIdx].topic = null
        }
      })
    },
    onEditorChange: function ({ quill, html, text }) {
      this.description = html
    },
    getIdeas: function (schoolId, spaceId) {
      let queryId
      if (spaceId) {
        queryId = spaceId
      }
      if (this.editTopicId) {
        spaceApi.getIdeas(schoolId, queryId, this.editTopicId, true).then((res) => {
          this.ideas = this.ideas.concat(res.data)
        })
      } else {
        spaceApi.getIdeas(schoolId, queryId).then((res) => {
          this.ideas = this.ideas.concat(res.data)
        })
      }
    },
    getTopic: function () {
      this.isLoadingTopic = true
      topicApi.get(this.editTopicId)
        .then((res) => {
          this.title = res.data[0].title
          this.description = res.data[0].description
          this.isLoadingTopic = false
          this.topicImage = res.data[0].image
        })
        .catch((err) => {
          console.error(err)
          this.showSnackbar = true
          this.snackbarMsg = this.$vuetify.t('$vuetify.TopicCreation.topicNotFound')
          this.isLoadingTopic = false
        })
    },
    assignIdeas: function (topicId) {
      const spaceSlug = this.$route.params['spaceSlug']
      topicApi.assignIdeas(topicId, this.selected)
        .then(res => {
          if (res == null || res.status < 400) {
            this.$router.push(
              { name: 'Topic', params: { spaceSlug: spaceSlug, topicId: topicId } }
            )
          } else {
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.serverError')
          }
        })
        .catch(() => {
          this.showSnackbar = true
          this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.networkError')
        })
    },
    onLoad: function (dataUri) {
      this.topicImage = dataUri
    },
    submit: function () {
      this.$validator.validate()
        .then(isFormValid => {
          // Do nothing if validation fails -  errors are displayed in UI
          if (!isFormValid) {
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.formError')
            return
          }

          const now = (new Date()).toISOString()
          const topic = {
            title: this.title,
            description: this.description,
            school_id: this.$store.getters.selected_school,
            created_by: this.$store.getters.userId,
            changed_by: this.$store.getters.userId,
            idea_space: this.$route.params['spaceId'],
            image: this.topicImage
          }

          if (this.editTopicId != null) {
            topic.id = this.editTopicId
            topic.changed_by = this.$store.getters.userId
            topic.changed_at = now
          } else {
            topic.phase = 'edit_topics'
            topic.config = {
              'edit_topics_started': now
            }
          }

          topicApi.createOrUpdate(topic)
            .then((res) => {
              if (res.status < 400 && res.data.length > 0) {
                const topicId = res.data[0].id

                if (this.selected.length > 0) {
                  this.assignIdeas(topicId)
                } else {
                  const spaceSlug = this.$route.params['spaceSlug']
                  this.$router.push(
                    { name: 'Topic', params: { spaceSlug, topicId } }
                  )
                }
              } else {
                this.showSnackbar = true
                this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.serverError')
              }
            })
            .catch(() => {
              this.showSnackbar = true
              this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.networkError')
            })
        })
        .catch(() => {
          this.showSnackbar = true
          this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.clientError')
        })
    },
    onSizeExceeded (size) {
      this.isFileSizeReset = false
      this.$refs.fileSizeUploadErrorDialog.show(size)
      setTimeout(() => {
        this.isFileSizeReset = true
      }, 50)
    }
  }
}
</script>

<style scoped lang="scss">
.select-ideas h2 {
  margin: 2em auto 1em;
}

.select-ideas .v-list {
  background-color: inherit;
}
</style>
